import { SIGN_IN_VALIDATIONS, SIGN_UP_VALIDATIONS, CHANGE_PASSWORD_VALIDATIONS } from "@/constants/form";

function hasAllFieldFilled(form, requiredFields) {
    return requiredFields.every(requiredField => !!form[requiredField])
}

function getAllFilledFields(form) {
    return Object.keys(form || {}).reduce((filteredForm, formField) => {
        if (form[formField]) {
            return {
                ...filteredForm,
                [formField]: form[formField]
            }
        }
        return filteredForm
    }, {})
}

function validateSigninForm(form) {
    return hasAllFieldFilled(form, SIGN_IN_VALIDATIONS)
}

function validateSignupForm(form) {
    return hasAllFieldFilled(form, SIGN_UP_VALIDATIONS)
}

function validateChangePasswordForm(form) {
    return hasAllFieldFilled(form, CHANGE_PASSWORD_VALIDATIONS)
}

export { validateSigninForm, validateSignupForm, validateChangePasswordForm, getAllFilledFields }
